/**
 * Componente e confirmacion de activacion - inactivacion de un Registro
 */
import { Box, Button, Flexbox, Heading, Modal, ModalBody, Stack, StackRow } from "codekit";

import { useState } from "react";

const Delcfirm = ({ handleConfirmAction, actionElement, acceptLabel="", cancelLabel="" }) => {
  const { text } = actionElement;

  const [isLoading, setIsLoading] = useState(false);

  /**
   * Funcion que maneja la confirmacion con valor TRUE de la operacion de activar - inactivar
   * al declarante
   */
  const handleConfirmActionTrue = () => {
    handleConfirmAction(true);
    setIsLoading(true);
  };

  return (
    <Modal size="sm" isOpen>
      <ModalBody size="xl">
        <Box textAlign="center">
          <Stack gap={7}>
            <Heading variant="heading-6">{text}</Heading>
            <StackRow forceWidth>
              <Flexbox justifyContent="center" alignItems="center" gap={4}>
                <Button
                  type="button"
                  variant="secondary"
                  disabled={isLoading}
                  size="2l"
                  minWidth={180}
                  onClick={() => handleConfirmAction(false)}
                >
                  {cancelLabel!=""?cancelLabel:"Cancelar"}
                </Button>
                <Button
                  type="button"
                  isLoading={isLoading}
                  variant="secondary-bold"
                  size="2l"
                  minWidth={180}
                  onClick={handleConfirmActionTrue}
                >
                  {acceptLabel!=""?acceptLabel:"Aceptar"}
                </Button>
              </Flexbox>
            </StackRow>
          </Stack>
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default Delcfirm;
